import store from '../../index'
import * as busca from '@/api/busca'

const state = {
  showModal: false,
  list: {}
}

const mutations = {
  TOGGLEMODAL (state, payload) {
    state.showModal = payload
  },
  SETRELACIONADOS (state, payload) {
    state.list = payload
  }
}

const actions = {
  toggleModal ({ commit }, payload) {
    commit('TOGGLEMODAL', payload)
  },
  async busca ({ commit }, payload) {
    let retorno = await busca.relacionados(payload)
    commit('SETRELACIONADOS', retorno.relacionados)
    store.dispatch('pedido/setDataRelacionados', Date.now())
  },
  async get ({ commit }, payload) {
    let retorno = await busca.getRelacionados(payload)
    commit('SETRELACIONADOS', retorno)
  },
  limpaRelacionados ({ commit }, payload) {
    commit('SETRELACIONADOS', [])
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/consultas/relacionados.js